import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "company-data" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = _resolveComponent("Image")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_CompanyType = _resolveComponent("CompanyType")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Image, {
      src: $props.logo,
      placeholder: "assets/company-placeholder.png",
      size: "4rem"
    }, null, 8 /* PROPS */, ["src"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Ellipsis, {
        class: "title",
        text: $props.name
      }, null, 8 /* PROPS */, ["text"]),
      _createVNode(_component_CompanyType, { type: $props.type }, null, 8 /* PROPS */, ["type"])
    ])
  ]))
}